// Vendor Libs
import {cloneDeep} from 'lodash';

const initialState = {
    fetched: false,
    fetching: false,
    error: null,
    response: null,
};

const actions = {
    DELETE_OFFERING: () => ({
        ...getInitialState(),
        fetching: true,
    }),

    DELETE_OFFERING_FULFILLED: (state, {response}) => ({
        ...state,
        error: null,
        fetched: true,
        fetching: false,
        response,
    }),

    DELETE_OFFERING_REJECTED: (state, {error}) => ({
        ...state,
        fetched: true,
        fetching: false,
        error,
    }),

    DELETE_OFFERING_RESET: () => getInitialState(),
};

function getInitialState() {
    return cloneDeep(initialState);
}

const reducer = (state = initialState, action) => (actions[action.type] ? actions[action.type](state, action) : state);

export default reducer;
